define([
	'components/toggleLink/toggleLink',
	'components/megadrop',
	'components/utilities/utilities',
	'components/mobileMenu/mobileMenu',
	'libs/flickity/flickity.pkgd.min'
], function (toggleLink, megadrop, utils, mobileMenu, Flickity) {
	'use strict';

	/**
	 * App
	 * This is the initialization file for all scripts.
	 * @version 2.0.0
	 * @see {@link http://youmightnotneedjquery.com/}
	 * @exports app
	 */
	var app = {

		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			// Initiates the DOMParser polyfill
			utils.domParserPolyfill();

			// Init menu
			megadrop.init();

			// Init mobile menu
			mobileMenu.init(document.querySelector('[data-type="mobileMenu"]'), {
				ajaxPath: mainConfig.menuAjaxPath,
				ajaxActivePane: mainConfig.menuAjaxActivePane,
				searchMethod: mainConfig.searchMethod,
				searchPage: mainConfig.searchPage,
				searchParameter: mainConfig.searchParameter,
				searchPlaceholder: mainConfig.searchPlaceholder
			});

			// Init toggle link
			toggleLink.init();

			// Init flickity
			this.flickity();

			// Demo plugins (for demo purpose only, remove this when you build a new web).
			this._loadPluginsDemonstration();

			// Expand search-field when focused (desktop)
			var searchInput = document.querySelector('#query');
			var pageHeader = document.querySelector('#page-header');
			var searchLabel = document.querySelector('.form-search label');
			var searchPlaceholder = searchLabel.textContent;
			utils.addEventListener(searchInput, 'focus', function () {
				utils.addClass(pageHeader, 'focused-search');
				searchInput.setAttribute('placeholder', searchPlaceholder);
			});
			utils.addEventListener(searchInput, 'blur', function () {
				utils.removeClass(pageHeader, 'focused-search');
				searchInput.setAttribute('placeholder', '');
				searchInput.value = '';
			});

			// Remove placeholder when search-field is focused (mobile)
			var mobileSearchInput = document.querySelector('#mobile-query');
			var mobileSearchPlaceholder = mobileSearchInput.getAttribute('placeholder');
			utils.addEventListener(mobileSearchInput, 'focus', function () {
				mobileSearchInput.setAttribute('placeholder', '');
			});
			utils.addEventListener(mobileSearchInput, 'blur', function () {
				mobileSearchInput.setAttribute('placeholder', mobileSearchPlaceholder);
			});

			// Toggle login-form when click on login-button
			var loginButton = document.querySelector('.loginbutton');
			var loginForm = document.querySelector('.loginform');
			var toggleClass = function (el, className) {
				if (utils.hasClass(el, className)) {
					utils.removeClass(el, className);
				} else {
					utils.addClass(el, className);
				}
			};
			utils.addEventListener(loginButton, 'click', function (e) {
				e.preventDefault();
				toggleClass(loginForm, 'active');
			});
		},


		/**
		 * Function that initiates the ajax-form functionality.
		 * @private
		 */
		_initAjaxForm: function () {
			var els = document.querySelectorAll('[data-type="ajaxForm"]');

			if (els.length > 0) {
				require(['components/ajaxForm/ajaxForm'], function (AjaxForm) {
					for (var i = 0; i < els.length; i++) {
						var el = els[i],
							ajaxForm = new AjaxForm();

						if (el.getAttribute('data-ajaxform-initiated') === null) {
							ajaxForm.init(el);
							el.setAttribute('data-ajaxform-initiated', true);
						}
					}
				});
			}
		},


		/**
		 * Function that initiates flickity.
		 * @private
		 */
		flickity: function () {
			var galleryElems = document.querySelectorAll('.carousel');

			for (var i = 0, len = galleryElems.length; i < len; i++) {
				var galleryElem = galleryElems[i];
				var cellCount = galleryElem.querySelectorAll('.carousel-cell').length;
				if (cellCount > 1) {
					new Flickity(galleryElem, {
						imagesLoaded: true,
						wrapAround: true,
						cellSelector: '.carousel-cell',
						autoPlay: 4000,
						pauseAutoPlayOnHover: true,
						friction: 0.50,
						pageDots: false,
						cellAlign: 'left'
					});
				}
			}
		},


		/**
		 * Loads all plugins in the framework to demonstrate them (this should be removed on "real" webprojects).
		 * @todo Remove this function from "real" projects.
		 * @private
		 */
		_loadPluginsDemonstration: function () {
			this._initAjaxForm();

			if (document.querySelectorAll('[data-type="poll"]').length > 0) {
				require(['components/poll/poll'], function (poll) {
					poll.init();
				});
			}

			if (document.querySelectorAll('[data-type="parallax"]').length > 0) {
				require(['components/parallax/parallax'], function (parallax) {
					parallax.init();
				});
			}

			if (document.querySelectorAll('[data-type="loadMore"]').length > 0) {
				require(['components/loadMore/loadMore'], function (loadMore) {
					loadMore.init();
				});
			}

			if (document.querySelectorAll('[data-type="share"]').length > 0) {
				require(['components/share/share'], function (share) {
					share.init();
				});
			}
		}
	};


	return app;
});



//////////////////
// WEBPACK FOOTER
// ./app.js
// module id = 1
// module chunks = 0